import {createTheme, darken, lighten, makeStyles, Theme} from '@material-ui/core';
import {
    DataGrid,
    getThemePaletteMode,
    GridCellParams,
    GridColDef,
    GridRowData,
    GridRowParams,
    GridSlotsComponent,
    GridSlotsComponentsProps,
} from '@material-ui/data-grid';
import React from 'react'
import {TableStyled} from './styled';

const Language = {
    filterPanelAddFilter: 'Adicionar Filtro',
    filterPanelDeleteIconLabel: 'Excluir',
    filterPanelOperators: 'Operadores',
    filterPanelOperatorAnd: 'E',
    filterPanelOperatorOr: 'OU',
    filterPanelColumns: 'Colunas',
    filterPanelInputLabel: 'Valor',
    filterPanelInputPlaceholder: 'Valor do Filtro',
    toolbarDensity: 'Tamanho',
    filterOperatorContains: 'Contém',
    filterOperatorEquals: 'Igual a',
    filterOperatorStartsWith: 'Começa com',
    filterOperatorEndsWith: 'Termina com',
    filterOperatorIs: 'É',
    filterOperatorNot: 'Não é',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'Está Vazio',
    filterOperatorIsNotEmpty: 'Não está vazio',
    toolbarDensityLabel: 'Tamanho',
    toolbarDensityCompact: 'Pequeno',
    toolbarDensityStandard: 'Médio',
    toolbarDensityComfortable: 'Grande',
    noRowsLabel: 'Sem Resultados',
    noResultsOverlayLabel: 'Não foi encontrado.',
    errorOverlayDefaultLabel: 'Ocorreu um erro.',
    toolbarExport: 'Salvar como...',
    toolbarExportLabel: 'Salvar como...',
    toolbarExportCSV: 'Baixar como CSV',
    toolbarColumns: 'Colunas',
    toolbarColumnsLabel: 'Selecionar Colunas',
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Mostrar Colunas',
    columnMenuFilter: 'Filtros',
    columnMenuHideColumn: 'Esconder',
    columnMenuUnsort: 'Não ordenar',
    columnMenuSortAsc: 'Ordernar em Ascendente',
    columnMenuSortDesc: 'Ordenar em Descendente',
    columnsPanelTextFieldLabel: 'Encontrar Coluna',
    columnsPanelTextFieldPlaceholder: 'Titulo da Coluna',
    columnsPanelDragIconLabel: 'Reordenar coluna',
    columnsPanelShowAllButton: 'Mostrar Todos',
    columnsPanelHideAllButton: 'Ocultar todas',
    toolbarFilters: 'Filtros',
    toolbarFiltersLabel: 'Mostrar filtros',
    toolbarFiltersTooltipHide: 'Esconder filtros',
    toolbarFiltersTooltipShow: 'Mostrar filtros',
    toolbarFiltersTooltipActive: (count: any) => count !== 1 ? `${count} filtros ativos` : `${count} filtros ativos`,
    footerRowSelected: (count: any) =>
        count !== 1
            ? `${count.toLocaleString()} Linhas Selecionadas`
            : `${count.toLocaleString()} Linhas Selecionadas`,

    // Total rows footer text
    footerTotalRows: 'Total de Linhas:',

    // Total visible rows footer text
    footerTotalVisibleRows: (visibleCount: any, totalCount: any) => `${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
}

interface PropsTable {
    rows: GridRowData[],
    columns: GridColDef[],
    cellClick?: (params?: GridCellParams) => void,
    rowClassName?: (params?: GridRowParams) => string,
    components?: GridSlotsComponent,
    componentsProps?: GridSlotsComponentsProps,
    onClick?: (id: any) => void
}

const defaultTheme = createTheme();
const useStyles = makeStyles(
    (theme: Theme) => {
        const getBackgroundColor = (color: any) =>
            getThemePaletteMode(theme.palette) === 'dark'
                ? darken(color, 0.6)
                : lighten(color, 0.6);

        const getHoverBackgroundColor = (color: any) =>
            getThemePaletteMode(theme.palette) === 'dark'
                ? darken(color, 0.5)
                : lighten(color, 0.5);

        return {
            root: {
                '& .super-app-theme--4': {
                    backgroundColor: getBackgroundColor(theme.palette.info.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
                    },
                },
                '& .super-app-theme--3': {
                    backgroundColor: getBackgroundColor(theme.palette.success.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
                    },
                },
                '& .super-app-theme--2': {
                    backgroundColor: getBackgroundColor(theme.palette.warning.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.warning.main),
                    },
                },
                '& .super-app-theme--1': {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
            },
        };
    },
    {defaultTheme},
);

const Table: React.FC<PropsTable> = ({
                                         rows,
                                         columns,
                                         cellClick = (params) => {},
                                         rowClassName = (params) => 'default',
                                         components,
                                         componentsProps,
                                         onClick = (id) => {},
                                     }) => {
    const classes = useStyles();

    return (
        <TableStyled className={classes.root}>
            <DataGrid
                localeText={Language}
                rows={rows}
                columns={columns}
                onCellClick={(params) => cellClick(params)}
                components={components}
                componentsProps={componentsProps}
                getRowClassName={
                    (params) => rowClassName(params)
                }
                onRowClick={(e) => {
                    // PKTransportadora + PK
                    const row = e;
                    
                    if(row !== null) onClick(row);
                }}
            />
        </TableStyled>
    )
}

export default Table;